export default __webpack_public_path__ + "static/featuresListItem5-a79951e677b88b320200321655cbb6c8.svg";